import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import MatchModal from "@/components/MatchModal";

const MatchDemoPage = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  const demoCurrentUser = {
    name: "You",
    photos: ["https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=face"],
  };

  const demoMatchedUser = {
    name: "Sarah",
    photos: ["https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop&crop=face"],
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center p-4">
      <div className="text-center mb-8">
        <h1 className="text-2xl font-bold text-[#1C3A7A] mb-2">Match Modal Demo</h1>
        <p className="text-gray-600">Click the button to preview the "It's a Match!" modal</p>
      </div>

      <Button
        onClick={() => setShowModal(true)}
        className="bg-[#FAB710] hover:bg-[#e8850f] text-white px-8 py-6 text-lg rounded-full"
      >
        Simulate a Match! 💕
      </Button>

      <Button
        variant="outline"
        onClick={() => navigate(-1)}
        className="mt-4"
      >
        Go Back
      </Button>

      <MatchModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        currentUser={demoCurrentUser}
        matchedUser={demoMatchedUser}
      />
    </div>
  );
};

export default MatchDemoPage;
